import { StyleSheet } from 'react-native'

export const themedToggleStyles = StyleSheet.create({
	view: {
		justifyContent: 'flex-start',
		alignItems: 'center',
		flexDirection: 'row',
		gap: 8,
	},
	toggle: {
		transform: [ {
			scale: 0.6
		} ],
	},
	text: {
		backgroundColor: 'blue',
	},
	
	overlay: {
		position: 'absolute',
		left: 0,
		top: 0,
		width: '100%',
		height: '100%',
	}
});
